import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30 * 1000,
      cacheTime: 15 * 60 * 1000,
    },
    mutations: {
      retry: 2,
    },
  },
})
